import { boot } from 'quasar/wrappers'
import EstadoService from '@/services/EstadoService'
import EmpresaService from '@/services/EmpresaService'
import AlicuotaService from '@/services/AlicuotaService'
import { useDefaultDataStore } from '@/stores/useDefaultDataStore'

export default boot(async () => {
  const estados = await EstadoService.index();
  const flow = await EstadoService.flow();
  const empresas = await EmpresaService.index();
  const alicuotas =  await AlicuotaService.index();
  const defaultDataStore = useDefaultDataStore();
  defaultDataStore.setEstados(estados);
  defaultDataStore.setEstadosFlow(flow);
  defaultDataStore.setEmpresas(empresas);
  defaultDataStore.setAlicuotas(alicuotas);
})
